"use strict";

exports.__esModule = true;
exports.config = void 0;
var config = exports.config = {
  id: "ticketing",
  name: "Ticketing",
  element: {
    props: {
      width: 1024,
      height: 768,
      rowCount: 12,
      columnCount: 12,
      timeRangeKind: "multiDay"
    },
    children: [{
      props: {
        dataSource: "Tickets",
        ticketsWithComments: true,
        gridRowStart: 1,
        gridRowEnd: 13,
        gridColumnStart: 1,
        gridColumnEnd: 13,
        configuration: {
          enablePagination: true,
          overFetchAll: false,
          defaultPageSize: 500
        },
        x: 0,
        y: 0,
        height: 64,
        width: 256
      },
      children: [{
        props: {
          id: "id",
          sortId: "_id",
          name: "ID",
          type: "string",
          enableSorting: true,
          canSearch: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "priority",
          name: "Priority",
          type: "ticketPriority",
          canSort: true,
          enableSorting: true,
          canFilter: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "created",
          name: "Created At",
          type: "date",
          usePlantTime: true,
          defaultSortOrder: "DESC",
          enableSorting: true,
          canSearch: true,
          dateFormat: "ShortDateTime",
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "age",
          sortId: "created",
          name: "Age",
          type: "age",
          enableSorting: true,
          canSearch: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "updated",
          name: "Updated At",
          type: "date",
          usePlantTime: true,
          defaultSortOrder: "DESC",
          enableSorting: true,
          canSearch: true,
          dateFormat: "ShortDateTime",
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "creator",
          name: "Creator",
          type: "creator",
          canSort: false,
          enableSorting: true,
          canFilter: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "types",
          name: "Types",
          type: "ticketTypes",
          canSort: false,
          enableSorting: false,
          canFilter: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "devices",
          name: "Devices",
          type: "devicesAndGroups",
          canFilter: true,
          enableSorting: false,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "title",
          name: "Summary",
          type: "string",
          enableSorting: true,
          canSearch: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "assignee",
          name: "Assignee",
          type: "assignee",
          canFilter: true,
          canSort: false,
          enableSorting: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "status",
          name: "Status",
          type: "status",
          enableSorting: true,
          canFilter: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }],
      type: "DataTable"
    }],
    type: "Report"
  }
};